import { render, staticRenderFns } from "./UserUnlink.vue?vue&type=template&id=c05811dc&"
import script from "./UserUnlink.vue?vue&type=script&lang=js&"
export * from "./UserUnlink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports